import React, { PropsWithChildren } from 'react';
import { styled } from 'styletron-react';
import { Col, Row } from 'react-bootstrap';

import { TechemTheme } from '@techem/techem-theme';

const ItemsRow = styled(Row, {
  height: '3px',
  marginTop: '22px',
  marginBottom: '22px',
  paddingTop: '17px',
  paddingBottom: '17px',
  '@media (max-width: 767px)': {
    paddingTop: '0',
    paddingBottom: '0'
  }
});

interface ContainerProps {
  id?: string;
}

export const WizardStepsContainer: React.FC<PropsWithChildren<ContainerProps>> = ({
  id,
  children
}) => {
  return (
    <Row id={id} className="justify-content-center">
      <Col xs={11} lg={10}>
        <Row className="justify-content-center">
          <Col md={9} lg="auto">
            <ItemsRow>{children}</ItemsRow>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const Step = styled(Col, {
  width: '80px',
  '@media (max-width: 991px)': {
    width: 'auto'
  },
  height: '3px',
  borderRadius: '3px',
  backgroundColor: TechemTheme.colors.backgroundSecondary
});

// TODO: Fix in future styletron updates where type inference works correctly.
// Replaced styletron's withStyle implementation as we get this error when using these components:
// JSX element type 'FilledStep' does not have any construct or call signatures. ts(2604)
//const FilledStep = withStyle(Step, {
//  backgroundColor: TechemTheme.colors.primary,
//});
const FilledStep = () => {
  return <Step $style={{ backgroundColor: TechemTheme.colors.primary }} />;
};

interface StepsProps {
  currentStep: number;
  totalSteps: number;
}

export const WizardSteps: React.FC<StepsProps> = ({ currentStep, totalSteps }) => {
  return (
    <>
      {[...Array(totalSteps)].map((_, i) => (
        <Col key={i} className="px-1">
          {i < currentStep ? <FilledStep /> : <Step />}
        </Col>
      ))}
    </>
  );
};
